import { vnModule_knockoutJS } from "@valnet/vnApp/vnModule_knockoutJS";
import { pageShell_template } from "~/components/templates/pageShell_template";
import { getActiveMenuLabel, getSectionNavLinks, } from "~/modules/menu_data";
import { header } from "./header";
export class SimplePageModule extends vnModule_knockoutJS {
    internalLoad(container) {
        try {
            this.build();
            this.insertIn(container);
            for (const element of this.content) {
                try {
                    ko.applyBindings(this.viewModel, element);
                }
                catch (error) {
                    console.error("Knockout binding failed for", element.id, error);
                }
            }
            this.loadSavedViewModule();
            this.fillPage();
        }
        finally {
            container.classList.remove("loading");
        }
    }
    setPageHeaderTitle(title) {
        const zoneHeader = this.getVnAppZone().app.getZoneByName("Header");
        const loadedModule = zoneHeader?.loadedModule;
        if (loadedModule instanceof header) {
            loadedModule.setHeaderTitle(title);
        }
    }
    buildContent() {
        const pageTitle = this.getPageTitle();
        this.setPageHeaderTitle(pageTitle);
        this.tpl = new pageShell_template(`${this.getModuleName()}Page`, this.viewModel, this, pageTitle, this.getNavLinks());
        return [this.tpl.build()];
    }
    fillPage() {
        // page-specific loading can override
    }
    getPageTitle() {
        return getActiveMenuLabel();
    }
    getNavLinks() {
        return getSectionNavLinks();
    }
}
